<template>
	<div class="container">
		<div class="main_box">
			<!--联系我们-->
			<fixed></fixed>
			<!--联系我们-->
			<!--导航-->
			<navbar :pageName="''"></navbar>
			<!--导航-->
			<!--块1-->
			<div class="block_1"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="msg_box"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="300"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<img class="img" src="../../assets/SSB/logo.webp" />
					<div class="tit">Scientific Strategy Board</div>
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2">
				<div class="block_2_main"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="500"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="list_box">
						<div class="list_el">
							<van-image width="90%" height="auto" :src="require('@/assets/SSB/ren_1.webp')" />
							<div class="tit">Albert P. Pisano</div>
							<div class="txt">
								Chair<br />
								Scientific Strategy Board
							</div>
							<div class="btn_box_more btn_box" @click="goInfo('AlbertP.Pisano')">
								Learn More<img src="../../assets/img/组 32@2x.png" />
							</div>
						</div>
						<div class="list_el">
							<van-image width="90%" height="auto" :src="require('@/assets/SSB/ren_2.webp')" />
							<div class="tit">Michael Mina</div>
							<div class="txt">
								Co-Chair<br />
								Scientific Strategy Board
							</div>
							<div class="btn_box_more btn_box" @click="goInfo('MichaelMina')">
								Learn More<img src="../../assets/img/组 32@2x.png" />
							</div>
						</div>
						<div class="list_el">
							<van-image width="90%" height="auto" :src="require('@/assets/SSB/ren_3.webp')" />
							<div class="tit">Ping Liu</div>
							<div class="txt">
								Director<br />
								Scientific Strategy Board
							</div>
							<div class="btn_box_more btn_box" @click="goInfo('PingLiu')">
								Learn More<img src="../../assets/img/组 32@2x.png" />
							</div>
						</div>
						<div class="list_el">
							<van-image width="90%" height="auto" :src="require('@/assets/SSB/ren_4.webp')" />
							<div class="tit">Liangfang Zhang</div>
							<div class="txt">
								Special Advisor<br />
								Scientific Strategy Board
							</div>
							<div class="btn_box_more btn_box" @click="goInfo('LiangfangZhang')">
								Learn More<img src="../../assets/img/组 32@2x.png" />
							</div>
						</div>
						<div class="list_el">
							<van-image width="90%" height="auto" :src="require('@/assets/SSB/ren_5.webp')" />
							<div class="tit">Kevin Ban</div>
							<div class="txt">
								Medical Advisor<br />
								Scientific Strategy Board
							</div>
							<div class="btn_box_more btn_box" @click="goInfo('KevinBan')">
								Learn More<img src="../../assets/img/组 32@2x.png" />
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--块2-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navbar from '@/component/nav.vue'  //导航组件
import footerBox from '@/component/footer.vue'  //版权组件
import fixed from '@/component/fixed.vue'  //联系我们悬浮
export default {
	components:{
		navbar,
		footerBox,
		fixed,
	},
	data() {
		return {
			isLoading: true,  //界面loading
		}
	},
	created(){
		let that = this;
		window.scroll(0, 0);
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		//点击查看详情
		goInfo(value) {
			let that = this;
			that.$router.push({ path: '/scientific-strategy-board-info', query: { name: value } });
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	width: 100%;
	height: auto;
	//块2
	.block_2{
		width: 100%;
		background: linear-gradient( 180deg, #FFFFFF 0%, #F6FCFF 100%);
		.block_2_main{
			width: 100%;
			margin: 0 auto;
			padding: 30px 30px 30px 30px;
			.list_box{
				.list_el{
					padding: 30px 0;
					text-align: center;
					.btn_box{
						margin-top: 15px;
					}
					.txt{
						padding-top: 5px;
						font-size: 18px;
					}
					.tit{
						padding: 24px 0 6px 0;
						font-size: 32px;
					}
				}
			}
		}
	}
	//块1
	.block_1{
		width: 100%;
		padding: 30px 0 30px 0;
		background: linear-gradient( 90deg, #0062B0 0%, #0B318F 100%);
		.msg_box{
			text-align: center;
			.tit{
				padding-top: 10px;
				font-size: 28px;
				color: #ffffff;
			}
			.img{
				width: 95px;
			}
		}
	}
	/*按钮*/
	.btn_box_more{
		display: inline-block;
		padding: 0 28px;
		height: 42px;
		line-height: 44px;
		font-size: 20px;
		color: #0B318F;
		background: transparent;
		border-radius: 22px 22px 22px 22px;
		border: 1px solid #0B318F;
		text-align: center;
		cursor: pointer;
		img{
			width: 20px;
			position: relative;
			top: 10px;
			left: 10px;
			transition: all 0.3s;
		}
	}
	.btn_box_more:hover{
		img{
			transform: translateX(6px);
		}
		background-color: #f5f8fa;
	}
}
</style>
